
(function ($, Drupal) {
  Drupal.behaviors.fancyBox = {

    initialized: false,

    attach: function (context, settings) {
      if(!this.initialized){
        this.initialized = true;
        this.init(context, settings);
      }
    },

    init: function (context, settings) {
      let fancyBoxTag = 'a.fancybox-btn';

      initHotelRoomGallery();
      $(fancyBoxTag).on('click', function(e){
          e.preventDefault();
      });

      function initHotelRoomGallery() {
        $(fancyBoxTag).fancybox({
          'transitionIn'	:	'elastic',
          'transitionOut'	:	'elastic',
          'speedIn'		:	600, 
          'speedOut'		:	200, 
          'overlayShow'	:	false,
          'true':true,
          'hideOnContentClick': true,
          'btnTpl' : {
            'close' : '<button title="Close" data-fancybox-close class="fancybox-item fancybox-close" title="{{CLOSE}}">Close</button>',
           },
        });
      }

      $(".various").fancybox({
          type: "iframe", //<--added
          maxWidth: 800,
          maxHeight: 600,
          fitToView: false,
          width: '70%',
          height: '70%',
          autoSize: false,
          closeClick: false,
          openEffect: 'none',
          closeEffect: 'none',
          baseClass: 'fancybox-video'
      });
    }
  };
})(jQuery, Drupal);